import Consts from "Interfaces/Consts";

type Props = {
    btnClass?: string;
    txtOpen?: string;
    txtClose?: string;
    showMore: () => void;
    isOpen: boolean;
}

const ShowMoreButton = ({ btnClass = '', txtOpen = Consts.showMore, txtClose = Consts.close, showMore, isOpen }: Props) => {

        return (
            <button type="button"                
                className={btnClass}
                onClick={showMore}>

                <span className={`${isOpen ? ' d-none' : ' d-block'} `}>{txtOpen} <i className="fa fa-fw fa-plus"></i></span>
                <span className={`${isOpen ? ' d-block' : ' d-none'} `}>{txtClose} <i className="fa fa-fw fa-minus"></i></span>
                
            </button>
        );
}

export default ShowMoreButton;
